import { Card } from '@unfold/card';
import {
  styled,
  layers,
  Theme,
  isPropNotEqualTo,
  flexColumn,
  Colors,
} from '@unfold/theme';
import { isNumber } from '@unfold/utils';

import { SizeTable } from '../../common/types';

import { maxDimensions, gutter, modalPadding } from './constants';
import { IDialogContainerProps, IDialogBodyProps } from './types';

export const DialogContainer = styled(Card, {
  shouldForwardProp: (prop) => isPropNotEqualTo(prop, 'width'),
})<IDialogContainerProps>`
  ${flexColumn}
  height: auto;
  max-height: ${maxDimensions};
  left: 0px;
  margin: ${gutter}px auto;
  max-width: ${maxDimensions};
  position: absolute;
  right: 0;
  width: ${({ size, width }): string =>
    width
      ? isNumber(width)
        ? `${width}px`
        : width
      : size
      ? `${SizeTable[size]}px`
      : 'auto'};
  z-index: ${layers.dialog};
  background-color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.WHITE : Colors.G100};

  @media (min-width: 320px) and (max-width: 480px) {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    max-width: 100%;
    width: 100%;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 0;
  top: -48px;
  z-index: 9999;
`;

export const DialogBody = styled.div<IDialogBodyProps>`
  flex: 1 1 auto;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ hasHeader, hasFooter, hasPadding }): string => {

    if(!hasPadding) {
      return '0';
    }

    return `${!hasPadding || hasHeader ? '0' : `${modalPadding}px`}
      ${!hasPadding ? '0' : `${modalPadding}px`}
      ${!hasPadding || hasFooter ? `0` : `${modalPadding}px`}
      ${!hasPadding ? '0' : `${modalPadding}px`}` ;
  }};
  border-top-style: solid;
  border-bottom-style: solid;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-top-color: ${({ hasTopBorder }): string =>
    hasTopBorder ? Colors.G400 : 'transparent'};
  border-bottom-color: ${({ hasBottomBorder }): string =>
    hasBottomBorder ? Colors.G400 : 'transparent'};
  transition: border-color 0.15s;

  @media (min-width: 320px) and (max-width: 480px) {
    overflow-y: auto;
    height: 100%;
  }
`;
